(function () {
  function init() {
    var header = document.querySelector(".nds-header--sticky");
    if (!header) return;

    function onScroll() {
      if (window.scrollY > 20) header.classList.add("nds-header--scrolled");
      else header.classList.remove("nds-header--scrolled");
    }

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
